import React, { useEffect } from 'react';
import SwaggerUI from 'swagger-ui-react';
import 'swagger-ui-react/swagger-ui.css';
import styled from "styled-components";
import { DIMENSIONS } from "utils/Dimensions";
import COLORS from "scss/colors.module.scss";
import { getLogoSrc, getTitle } from "app/common/utils/Logo";

import yaml from 'js-yaml';
import swaggerDocs from './swagger-api-docs.yaml';
import CircularProgress from "@material-ui/core/CircularProgress";


const OpenAPIDocumentation = () => {
    const config = window.appStore.configStore.config;
    const [swaggerSpec, setSwaggerSpec] = React.useState(null);

    useEffect(() => {
        // Loading the YAML file and set it as the swagger spec
        fetch(swaggerDocs)
        .then((response) => response.text())
        .then((yamlContent) => setSwaggerSpec(yaml.load(yamlContent)));
    }, []);                

    return (
            <MainDiv>
                <div
                    className="sticky-top d-flex"
                    style={{
                        height: DIMENSIONS.header1,
                        backgroundColor: COLORS.THEME_COLOR,
                        justifyContent: "center",
                    }}
                    >
                    <img
                        src={getLogoSrc()}
                        alt={config?.site?.title || "logo"}
                        style={{
                        height: 28,
                        marginLeft: 20,
                        marginTop: 8,
                        }}
                    />
                    <h4 style={{ color: "white", padding: 8 }}>{getTitle()}</h4>
                </div>
                {!swaggerSpec ?
                    <CircularDiv>
                        <CircularProgress style={{marginRight: 5}} color="inherit" /> Loading...
                    </CircularDiv>
                :
                    <SwaggerUI
                        // url="/swagger-docs.yaml"
                        spec={swaggerSpec}
                    />
                }
                
            </MainDiv>
    )
};

const MainDiv = styled.div`
    min-height: 100vh;
    background: #f5f5f5;
    flex-grow: 1;
    overflow: hidden;
`;

const CircularDiv = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
`;

export default OpenAPIDocumentation;
